const clientLowerCase = process.env.REACT_APP_CLIENT

const clientUpperCase = clientLowerCase.toUpperCase()

const capitalize = str => {
  if (!str) return ""
  return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase()
}

const clientCapitalized = capitalize(clientLowerCase)

export { clientLowerCase, clientUpperCase, clientCapitalized }
